/* Mama Bundle — shared theme behaviors:
   fade-in-on-scroll, header hide/scroll, mobile menu, smooth anchor scroll,
   FAQ accordions + category pills, product gallery, variant picker, quantity
   steppers, ice/heat toggle, reviews show-more, sticky add-to-cart bar. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- Fade in on scroll ---- */
    var faders = document.querySelectorAll('.js-fade-in');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '-80px' });
      faders.forEach(function (el) { io.observe(el); });
    } else {
      faders.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ---- Header scroll behavior ---- */
    var header = document.getElementById('site-header');
    if (header) {
      var hideOnScroll = header.getAttribute('data-hide-on-scroll') === 'true';
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        header.classList.toggle('is-scrolled', y > 20);
        if (hideOnScroll) header.classList.toggle('is-hidden', y > 80);
      }, { passive: true });
    }

    /* ---- Mobile menu ---- */
    var menuToggle = document.getElementById('mobile-menu-toggle');
    var mobileMenu = document.getElementById('mobile-menu');
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function () {
        mobileMenu.classList.toggle('is-open');
      });
      mobileMenu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { mobileMenu.classList.remove('is-open'); });
      });
    }

    /* ---- Smooth anchor scroll for same-page #links ---- */
    document.querySelectorAll('.js-anchor-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        var hashIndex = href.indexOf('#');
        if (hashIndex === -1) return;
        var id = href.slice(hashIndex + 1);
        var target = document.getElementById(id);
        // Only intercept if the target exists on this page
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });

    /* ---- FAQ category pills ---- */
    document.querySelectorAll('[data-faq-app]').forEach(function (app) {
      var pills = app.querySelectorAll('[data-faq-category]');
      var groups = app.querySelectorAll('[data-faq-group]');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var cat = pill.getAttribute('data-faq-category');
          pills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
          groups.forEach(function (g) {
            g.style.display = g.getAttribute('data-faq-group') === cat ? '' : 'none';
          });
        });
      });
    });

    /* ---- FAQ / accordion items (also product accordion) ---- */
    document.querySelectorAll('.js-faq-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.js-faq-item');
        if (item) item.classList.toggle('is-open');
      });
    });

    /* ---- Product gallery ---- */
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var mainImg = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var current = 0;
      function show(index) {
        if (!thumbs.length) return;
        if (index < 0) index = thumbs.length - 1;
        if (index >= thumbs.length) index = 0;
        current = index;
        var thumb = thumbs[index];
        if (mainImg && thumb) mainImg.src = thumb.getAttribute('data-full');
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      }
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { show(i); });
      });
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
    });

    /* ---- Product details: variant picker, qty, add to cart ---- */
    document.querySelectorAll('[data-product-app]').forEach(function (app) {
      var select = app.querySelector('[data-variant-select]');
      var swatches = app.querySelectorAll('.js-variant-swatch');
      var priceEl = app.querySelector('[data-price]');
      var addTotalEl = app.querySelector('[data-add-total]');
      var addBtn = app.querySelector('[data-add-btn]');
      var qtyInput = app.querySelector('[data-qty-input]');
      var qtyValue = app.querySelector('[data-qty-value]');
      var form = app.querySelector('.js-product-form');
      var selectedOptions = {};
      var qty = 1;

      // seed selectedOptions from currently selected swatches
      swatches.forEach(function (sw) {
        if (sw.classList.contains('is-selected')) {
          selectedOptions[sw.getAttribute('data-option-position')] = sw.getAttribute('data-value');
        }
      });

      function currentVariantOption() {
        return select ? select.options[select.selectedIndex] : null;
      }

      function priceUnitCents() {
        var opt = currentVariantOption();
        return opt ? parseInt(opt.getAttribute('data-price-raw'), 10) : 0;
      }

      function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

      function syncFromSelect() {
        var opt = currentVariantOption();
        if (!opt) return;
        if (priceEl) priceEl.textContent = opt.getAttribute('data-price');
        updateAddTotal();
        var available = !opt.disabled;
        if (addBtn) {
          addBtn.disabled = !available;
          if (!available) addBtn.textContent = 'OUT OF STOCK';
        }
      }

      function updateAddTotal() {
        if (addTotalEl) addTotalEl.textContent = formatMoney(priceUnitCents() * qty);
      }

      function selectVariant() {
        if (!select) return;
        // find option whose data-option{n} all match selectedOptions
        for (var i = 0; i < select.options.length; i++) {
          var opt = select.options[i];
          var match = true;
          for (var pos in selectedOptions) {
            if (opt.getAttribute('data-option' + pos) !== selectedOptions[pos]) { match = false; break; }
          }
          if (match) { select.selectedIndex = i; break; }
        }
        syncFromSelect();
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          var pos = sw.getAttribute('data-option-position');
          selectedOptions[pos] = sw.getAttribute('data-value');
          swatches.forEach(function (other) {
            if (other.getAttribute('data-option-position') === pos) {
              other.classList.toggle('is-selected', other === sw);
            }
          });
          selectVariant();
        });
      });

      function setQty(n) {
        qty = Math.max(1, n);
        if (qtyValue) qtyValue.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
        updateAddTotal();
      }
      var minus = app.querySelector('[data-qty-minus]');
      var plus = app.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var opt = currentVariantOption();
          if (!opt || opt.disabled || !window.MamaCart) return;
          window.MamaCart.add(opt.value, qty);
        });
      }

      /* sticky bar */
      var stickyBar = document.querySelector('[data-sticky-bar]');
      var anchor = app.querySelector('[data-add-anchor]');
      if (stickyBar && anchor) {
        var dismissed = false;
        window.addEventListener('scroll', function () {
          if (dismissed) return;
          var rect = anchor.getBoundingClientRect();
          stickyBar.classList.toggle('is-visible', rect.bottom < 0);
        }, { passive: true });

        var sQtySpan = stickyBar.querySelector('[data-sticky-qty]');
        var sMinus = stickyBar.querySelector('[data-sticky-minus]');
        var sPlus = stickyBar.querySelector('[data-sticky-plus]');
        var sAdd = stickyBar.querySelector('.js-sticky-add');
        var sDismiss = stickyBar.querySelector('[data-sticky-dismiss]');
        var sQty = 1;
        function setSQty(n) { sQty = Math.max(1, n); if (sQtySpan) sQtySpan.textContent = sQty; }
        if (sMinus) sMinus.addEventListener('click', function () { setSQty(sQty - 1); });
        if (sPlus) sPlus.addEventListener('click', function () { setSQty(sQty + 1); });
        if (sAdd) sAdd.addEventListener('click', function () {
          var opt = currentVariantOption();
          if (opt && !opt.disabled && window.MamaCart) window.MamaCart.add(opt.value, sQty);
        });
        if (sDismiss) sDismiss.addEventListener('click', function () {
          dismissed = true; stickyBar.classList.remove('is-visible');
        });
      }

      syncFromSelect();
    });

    /* ---- Ice / Heat toggle controlling the How it works section ---- */
    var iceHeatToggle = document.querySelector('[data-ice-heat-toggle]');
    var howSection = document.querySelector('[data-how-it-works]');
    if (iceHeatToggle && howSection) {
      var heading = howSection.querySelector('[data-howitworks-heading]');
      function applyMode(mode) {
        howSection.querySelectorAll('[data-step-mode]').forEach(function (step) {
          step.style.display = step.getAttribute('data-step-mode') === mode ? '' : 'none';
        });
        if (heading) {
          heading.innerHTML = 'Three gentle steps to <em>' + (mode === 'heat' ? 'soothing warmth' : 'cooling relief') + '</em>';
        }
      }
      iceHeatToggle.querySelectorAll('[data-mode-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-mode-btn');
          iceHeatToggle.querySelectorAll('[data-mode-btn]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          applyMode(mode);
        });
      });
      applyMode('ice');
    }

    /* ---- Reviews show more / less ---- */
    var reviewsToggle = document.querySelector('[data-reviews-toggle]');
    if (reviewsToggle) {
      var expanded = false;
      var cards = document.querySelectorAll('[data-review-card]');
      var showingEl = document.querySelector('[data-reviews-showing]');
      var total = parseInt(reviewsToggle.getAttribute('data-total'), 10);
      reviewsToggle.addEventListener('click', function () {
        expanded = !expanded;
        cards.forEach(function (card) {
          var idx = parseInt(card.getAttribute('data-index'), 10);
          card.classList.toggle('is-hidden', !expanded && idx > 3);
        });
        if (showingEl) showingEl.textContent = expanded ? total : 3;
        reviewsToggle.textContent = expanded ? 'Show Less' : 'Show All ' + total + ' Reviews';
      });
    }
  });
})();
